import { parseResponse } from 'hono/client';
import { getIdApi } from '../id/getIdApi';

export const getPendingInvites = async () => {
  const api = getIdApi();
  const response = await api.profile.v1['pending-invites'].$get();
  return parseResponse(response);
};

export const acceptUserInvite = async (params: { inviteId: number; organizationId: string }) => {
  const api = getIdApi();
  const response = await api.organizations.v1.invites.accept.$put({
    json: params,
  });
  return parseResponse(response);
};
